<template>
  <div>
    <div class="d-flex justify-center">
      <div class="_60_w" v-if="!loading && section">
        <v-card class="rounded_max" elevation="1" style="overflow: hidden">
          <div class="strip" :style="`background:${section.color}`"></div>
          <div class="d-flex justify-space-between px-2">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  :to="`/section/inclass/${$route.params.idSection}/${$route.params.idCourse}`"
                  icon
                  ><v-icon>mdi-reply</v-icon></v-btn
                >
              </template>
              <span>Back</span>
            </v-tooltip>
          </div>
          <div class="px-5 pb-5" v-if="module">
            <h3>{{ module.title }}</h3>
            <p class="mb-0 mt-2" v-html="module.description"></p>
          </div>
        </v-card>
        <div class="mt-3" v-if="answered == 0">
          <v-card class="rounded_max pa-3" elevation="1" color="#f6f6f6">
            <v-row no-gutters>
              <v-col cols="12" md="4" lg="4" v-for="(item, i) in list" :key="i">
                <div class="pa-3">
                  <v-card
                    class="pa-3 d-flex align-center"
                    @click="selected = item.val"
                    :color="selected == item.val ? item.color : ''"
                    :dark="selected == item.val"
                    flat
                  >
                    <v-icon large class="mr-3"> {{ item.icon }} </v-icon>
                    <h4 class="text-center">
                      {{ item.key }}
                    </h4>
                  </v-card>
                </div>
              </v-col>
            </v-row>
            <div class="px-3">
              <v-textarea
                v-model="notes"
                dense
                placeholder="Notes"
                hide-details
                flat
                solo
                auto-grow
              ></v-textarea>
            </div>
            <div class="d-flex justify-end pa-3" v-if="selected">
              <v-btn
                dark
                :color="section.color"
                @click="absen"
                depressed
                class="text-capitalize"
                >Post</v-btn
              >
            </div>
            <v-overlay
              :absolute="true"
              color="white"
              opacity="1"
              :value="saving"
            >
              <v-progress-circular
                indeterminate
                class="mr-2"
                :color="section.color"
              ></v-progress-circular>
              <b :style="`color:${section.color}`">Loading...</b>
            </v-overlay>
          </v-card>
        </div>

        <v-card
          class="rounded_max mt-3 pb-3"
          elevation="1"
          v-if="answered == 1"
        >
          <div
            class="d-flex align-center justify-center flex-column"
            style="height: 100%"
          >
            <img
              src="../../../../assets/img/gundam/LMS Aset Illustration Jawaban Tersimpan.png"
              height="150px"
              alt=""
            />
            <h3>Your answer has been saved</h3>
          </div>
        </v-card>
      </div>

      <div v-if="loading" class="_60_w">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="pa-3">
              <v-skeleton-loader
                type="image"
                class="rounded_lg"
                height="230px"
              ></v-skeleton-loader>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- CREATE QUIZ -->
    <div class="pa-2">
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchModule"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import DialogMedium from "../../../dialog/dialogMedium.vue";
import DialogSmall from "../../../dialog/dialogSmall.vue";
export default {
  components: {
    //  DialogMedium,
    DialogSmall,
  },
  computed: {
    ...mapState({
      id: (state) => state.id,
    }),
  },
  name: "moduleAttandence",
  data() {
    return {
      loadQuest: false,
      loading: true,
      dataSet: null,
      section: null,
      module: null,
      d_create: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      answered: null,
      materi_id: null,
      list: [
        {
          key: "Present",
          val: "present",
          icon: "mdi-account-check",
          color: "green",
        },
        {
          key: "Permit",
          val: "permit",
          icon: "mdi-account-injury-outline",
          color: "orange",
        },
        {
          key: "Alpha",
          val: "alpha",
          icon: "mdi-account-remove",
          color: "red",
        },
      ],
      selected: "",
      notes: "",
      saving: false,
    };
  },
  computed: {},
  mounted() {
    let answer = JSON.parse(localStorage.getItem("answer"));
    if (answer) {
      this.answer = answer;
    }
    this.fetchSection();
    this.fetchModule();
  },
  methods: {
    fetchSection() {
      this.loading = true;
      let data = {
        path: `manage/course/section?filter[id]=${this.$route.params.idSection}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          this.section = data.data[0];
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchModule() {
      let module = this.$route.params.idModule;
      let instance = this.$route.params.idInstance;
      this.loading = true;
      let data = {
        path: `scholar/course/section/module/${module}/${instance}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          this.module = data.data;
          this.answered = data.is_input_attendance;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    absen() {
      let section = this.$route.params.idSection;
      let instance = this.$route.params.idInstance;
      let body = {
        course_section_id: section,
        course_attendance_id: instance,
        attend: this.selected,
        notes: this.notes,
      };
      let data = {
        path: `scholar/course/section/module/attendance/post`,
        body: body,
      };
      this.saving = true;
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.saving = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.fetchModule();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
.strip {
  padding: 3px;
  height: 10px;
  width: 100%;
  border-radius: 0 !important;
}
</style>
